export default function scaleImage(url, canvasWidth, canvasHeight) {
    return new Promise((resolve) => {
        const image = new Image();

        image.onload = () => {
            let canvas = document.createElement('canvas');

            let context = canvas.getContext('2d');

            canvas.width = canvasWidth;
            canvas.height = canvasHeight;

            const imageWidth = image.naturalWidth;
            const imageHeight = image.naturalHeight;

            const scale = Math.min(canvasWidth / imageWidth, canvasHeight / imageHeight);

            const scaledWidth = imageWidth * scale;
            const scaledHeight = imageHeight * scale;

            context.drawImage(
                image,
                (canvasWidth - scaledWidth) / 2,
                (canvasHeight - scaledHeight) / 2,
                scaledWidth,
                scaledHeight,
            );

            let pngDataUrl = canvas.toDataURL('image/png');

            resolve(pngDataUrl);
        };

        image.src = url;
    });
}
